import { api } from './client';

export interface DeptSerialLookup {
  serialNo: string;
  itemId: number;
  itemCode: string;
  itemName: string;
  qty: number;
  status: string;
  department: string | null;
  lastBin: { code: string; name: string } | null;
}

export interface DeptTransferRow {
  id: number;
  transferNo: string;
  direction: 'Out' | 'In';
  department: string;
  transferDate: string;
  remarks: string;
  createdBy: string | null;
  createdAt: string;
  totalQty: number;
  items: { serialNo: string; itemCode: string; itemName: string; qty: number }[];
}

export interface DeptLocation {
  id: number;
  code: string;
  name: string;
  level: string;
  capacity: number;
  used: number;
  free: number | null;
}

export async function listDeptLocations(): Promise<DeptLocation[]> {
  const r = await api.get<DeptLocation[]>('/dept-transfer/locations');
  return r.data;
}

export async function lookupDeptSerial(serialNo: string): Promise<DeptSerialLookup> {
  const r = await api.get<DeptSerialLookup>(`/dept-transfer/lookup/${encodeURIComponent(serialNo)}`);
  return r.data;
}

export async function listDeptTransfers(): Promise<DeptTransferRow[]> {
  const r = await api.get<DeptTransferRow[]>('/dept-transfer');
  return r.data;
}

export async function createDeptTransfer(payload: {
  direction: 'Out' | 'In';
  department: string;
  remarks?: string;
  items: { serialNo: string; locationCode?: string }[];
}): Promise<{ id: number; transferNo: string; totalQty: number; units: number }> {
  const r = await api.post('/dept-transfer', payload);
  return r.data;
}
